var map = {
	"./dashboard-device-preview.png": 88003,
	"./gift-dashboard.svg": 91310,
	"./help/audits/ask-patty-audits.png": 14435,
	"./help/audits/audit-history-detail.png": 84276,
	"./help/audits/audit-performance-chart.png": 23001,
	"./help/audits/latest-audit-results.png": 93178,
	"./help/audits/view-audit.png": 64833,
	"./help/courses/course-detail-panel.png": 58862,
	"./help/courses/course-list-section.png": 90446,
	"./help/courses/view-more-detail-button.png": 45096,
	"./help/dashboard/annual-audit-scores-overview.png": 6795,
	"./help/dashboard/dashboard-facts-overview.png": 32766,
	"./help/dashboard/notifications-overview.png": 64092,
	"./help/dashboard/request-visit-section.png": 70585,
	"./help/dashboard/starred-items-overview.png": 92206,
	"./help/dashboard/upcoming-visit-card.png": 16117,
	"./help/library/add-document-button.png": 99369,
	"./help/library/add-library-document-form.png": 54245,
	"./help/library/ai-assistant-card.png": 1659,
	"./help/library/categories-tabs-and-table.png": 68473,
	"./help/library/knowledge-library-search-card.png": 61905,
	"./help/library/view-library-document-form.png": 71095,
	"./help/messages/header-chat-icon.png": 79804,
	"./help/messages/panel-main.png": 33620,
	"./help/messages/send-new-form.png": 55644,
	"./help/messages/thread-view.png": 25708,
	"./help/navigation/header-mobile.png": 82126,
	"./help/navigation/header-msg-notifcation.png": 27842,
	"./help/navigation/header.png": 11029,
	"./help/navigation/sidebar-chat-with-us.png": 45543,
	"./help/navigation/sidebar-header.png": 82644,
	"./help/navigation/sidebar-logout.png": 73561,
	"./help/navigation/sidebar-nav-items.png": 26239,
	"./help/notifications/alert-types.png": 78164,
	"./help/notifications/header-bell-icon.png": 20335,
	"./help/notifications/panel-overview.png": 15146,
	"./help/notifications/view-detail-modal.png": 20957,
	"./help/team/add-document-button.png": 75219,
	"./help/team/add-document-form.png": 88909,
	"./help/team/add-employee-button.png": 57582,
	"./help/team/add-employee-panel.png": 7758,
	"./help/team/connect-website-prompt.png": 77644,
	"./help/team/employee-audits-list.png": 60071,
	"./help/team/employee-courses-list.png": 22367,
	"./help/team/employee-detail-header.png": 61805,
	"./help/team/employee-documents-list.png": 50723,
	"./help/team/employee-requests.png": 38154,
	"./help/team/employee-resources-tabs.png": 46948,
	"./help/team/my-team-table.png": 1762,
	"./help/team/user-permissions.png": 57395,
	"./icons/avatar.png": 48589,
	"./icons/check-icon.svg": 90052,
	"./icons/default-image.svg": 1117,
	"./icons/feedback-icon.svg": 75091,
	"./icons/feedback-icons/negative.svg": 69292,
	"./icons/feedback-icons/neutral.svg": 56318,
	"./icons/feedback-icons/positive.svg": 68676,
	"./icons/filled-star.svg": 72739,
	"./icons/star.svg": 35034,
	"./icons/thumbs-down-filled.svg": 23799,
	"./icons/thumbs-up-filled.svg": 47618,
	"./icons/trash.png": 95134,
	"./login-back-splash.png": 90112,
	"./logos/ipac-consulting-white.svg": 37236,
	"./logos/ipac-consulting.svg": 71220,
	"./logos/ipac-dashboard-beta.svg": 72255,
	"./logos/ipac-dashboard-view-only.svg": 44181,
	"./logos/ipac-dashboard-white.svg": 15544,
	"./logos/ipac-dashboard.svg": 13944,
	"./logos/ipac-loader/logo-loader.svg": 68035,
	"./logos/logomark-white.svg": 86210,
	"./logos/logomark.svg": 65702,
	"./mastercard-logo.svg": 64161,
	"./patty/guardian/construction.svg": 2057,
	"./patty/guardian/environment.svg": 72593,
	"./patty/guardian/hand-hygenie.svg": 88929,
	"./patty/guardian/health-safety.svg": 65927,
	"./patty/guardian/patty.svg": 4432,
	"./patty/guardian/record-keeping.svg": 56851,
	"./patty/guardian/steri.svg": 88371,
	"./patty/lottie/patty-404": 7588,
	"./patty/lottie/patty-404.json": 7588,
	"./patty/lottie/patty-floating": 5014,
	"./patty/lottie/patty-floating.json": 5014,
	"./patty/lottie/patty-wave": 46617,
	"./patty/lottie/patty-wave.json": 46617,
	"./patty/patty-avatar.svg": 16738,
	"./visa-logo.svg": 24444
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;